import {
  observable,
  action,
  toJS,
  runInAction
} from 'mobx';
import {ViewBase} from 'mutants-appfx';
import {Message} from 'tplus-components-touch';
import GuideApi from '../api/GuideApi';

  class GuideModal extends ViewBase {
    get type(){
      return 'GuideModal';
    }

    @observable checkStatus = false;
    @observable visible = false;
    @observable guides = [];//模糊查询的导购员
    @observable guide = {};//选中的导购员
    @observable choice = 'all';

    constructor(store,name){
      super(store,name);
    }

    @action
    show = (result,choice)=>{
      this.result = result;
      if(choice){
        this.choice = choice;
      }
      this.visible = true;
    }

    @action
    hide = ()=>{
      this.visible = false;
    }

    @action
    cancel = ()=>{
      this.result({});
      this.reset();
      this.hide();
    }

    @action
    searchGuide = async (keyword, other) => {
      const repsonse = await GuideApi.getGuides(keyword, other);
      runInAction(() => {
        let data = repsonse && repsonse.Data;
        this.guides = data || [];
        if (data && data.length > 0) {
          this.guide = data[0];
        } else {
          this.guide = '';
        }
      })
    }

    @action
    setChoice = (choice)=>{
      this.choice = choice;
    }

    @action
    setGuide = (guide)=>{
      this.guide = guide;
    }

    @action
    reset = () => {
      this.choice = 'all';
      this.guides = [];
      this.guide = '';
      this.checkStatus = false;
    }

    @action
    ok = ()=>{
      const guide = toJS(this.guide);
      const choice = toJS(this.choice);
      if(!guide.ID){
        Message.warn('请选择一个导购员!');
        return;
      }
      this.result({guide,choice});
      this.reset();
      this.hide();
    }

    @action
    setCheckStatus = (status) => {
      this.checkStatus = status
    }

    static fromJS(store) {
      return new GuideModal(store, 'GuideModal');
    }

  }
  export default GuideModal;
